// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1ASm1","info":"Note_info__2Xn4D","note":"Note_note__3XL8W","actions":"Note_actions__YPgcq"};